export const pageHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '15px',
};

export const backIconWrapperSx = {
  cursor: 'pointer',
  '&:hover': { opacity: 0.75 },
};

export const pageTitleStyle = {
  fontWeight: 500,
  padding: '5px 5px 5px 15px',
};

export const contentContainerSx = {
  background: 'white',
};

export const actionRowSx = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  marginBottom: '12px',
  gap: 2,
};

export const helperColumnSx = { width: { xs: '100%', md: '58.3333%' } };
export const actionColumnSx = {
  width: { xs: '100%', md: '41.6667%' },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 4,
  flexWrap: 'nowrap',
};

export const helperTextStyle = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '165%',
  color: '#6A5E71',
};

export const selectedCountStyle = {
  width: '117px',
  height: '16px',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '115%',
  textAlign: 'center',
  color: '#90388B',
  whiteSpace: 'nowrap',
};

export const composeButtonStyle = {
  width: '152px',
  height: '40px',
  borderRadius: '8px',
  background: '#702572',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '115%',
  textAlign: 'center',
  color: '#FFFFFF',
  whiteSpace: 'nowrap',
};

export const tableWrapperSx = {
  border: '1px solid #EAEAEA',
  borderRadius: '8px',
  overflow: 'hidden',
};
